import { useTopicType } from "@/contexts/TopicTypeContext";
import ResetIcon from "@images/pressList/icon-reload.svg";
import SearchFilterTag from "@PressListContainer/shared/components/SearchFilterTag/SearchFilterTag";
import { usePublicationListFilterState } from "@stores/publicationList";

import {
  EDITOR_INFO_CODE,
  STATUS_FILTER,
  StatusCode,
} from "./constants/filterCode.constants";
import * as S from "./PublicationListSearchResult.style";

interface SearchType {
  [key: string]: string | undefined;
}

const PublicationListSearchResult = () => {
  const [publicationListFilter, setPublicationListFilter] =
    usePublicationListFilterState();
  const { topicTypeData } = useTopicType();

  const { search, publicationListDataTotal, status, topicType } =
    publicationListFilter;

  const isSearch =
    (search && !!Object.keys(search).length) ||
    !!status.length ||
    !!topicType.length;

  const handleDeleteStatus = (currentCode: string) => {
    const deleteStatusFilter = status.filter(
      (filterCode) => filterCode !== currentCode,
    );

    setPublicationListFilter({
      ...publicationListFilter,
      status: deleteStatusFilter,
      page: 1,
    });
  };

  const handleDeleteSearch = (currentKey: string) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { [currentKey]: currentSearch, ...otherSearch } =
      search as SearchType;

    setPublicationListFilter({
      ...publicationListFilter,
      search: {
        ...otherSearch,
      },
      page: 1,
    });
  };

  const handleDeleteTopicType = (currentCode: string) => {
    const deleteTopicTypeFilter = topicType.filter(
      (filterCode) => filterCode !== currentCode,
    );

    setPublicationListFilter({
      ...publicationListFilter,
      topicType: deleteTopicTypeFilter,
      page: 1,
    });
  };

  const handleResetFilter = () => {
    setPublicationListFilter({
      ...publicationListFilter,
      search: {},
      status: [],
      topicType: [],
    });
  };

  const handleCheckPressIdSearch = (key: string, value: string) => {
    if (key !== "pressId") return value;

    const pressIdValue = value.replace(/#/g, "");

    return `#${pressIdValue}`;
  };

  return (
    <>
      {isSearch && (
        <S.SearchResult>
          <S.SearchResultText>Search Results for</S.SearchResultText>
          {search &&
            Object.entries(search).map(
              ([key, value]) =>
                value && (
                  <SearchFilterTag
                    key={key}
                    type="result"
                    text={handleCheckPressIdSearch(key, value)}
                    isAllInfo={!!(key === "allInfo" || key === "allEditorInfo")}
                    isUserInput
                    code={EDITOR_INFO_CODE[key]}
                    onClickDeleteButton={() => handleDeleteSearch(key)}
                  />
                ),
            )}

          {topicType &&
            topicType.map((topicTypeCode) => (
              <SearchFilterTag
                key={topicTypeCode}
                type="result"
                text={topicTypeData?.[topicTypeCode] || topicTypeCode}
                isAllInfo={false}
                isTopicType
                onClickDeleteButton={() => handleDeleteTopicType(topicTypeCode)}
              />
            ))}

          {status &&
            status.map((statusCode) => (
              <SearchFilterTag
                key={statusCode}
                type="result"
                text={STATUS_FILTER[statusCode as StatusCode]}
                isAllInfo={false}
                code={statusCode}
                onClickDeleteButton={() => handleDeleteStatus(statusCode)}
              />
            ))}
          <S.SearchTotalCount>({publicationListDataTotal})</S.SearchTotalCount>
          <S.ResetButton onClick={handleResetFilter}>
            <img src={ResetIcon} width={10} alt="filter reset icon" />
            <S.ResetButtonText>Filter Reset</S.ResetButtonText>
          </S.ResetButton>
        </S.SearchResult>
      )}
    </>
  );
};

export default PublicationListSearchResult;
